/**
 * OBJECTS section — minimal (§4 task 1.9): the root dictionary plus the
 * named-plot-style dictionary the LAYER 390 codes point at. AutoCAD reads
 * the rest of its object graph lazily; deeper xdict content (LAYOUT,
 * DIMSTYLE dictionaries) lands with Faz 2's PAGESETUP work.
 */

import type { DxfWriteContext } from '../types';
import type { DxfStreamWriter } from '../DxfStreamWriter';

export function writeObjectsSection(w: DxfStreamWriter, ctx: DxfWriteContext): void {
    const rootHandle = ctx.handles.entityHandle('dxf:rootdict');
    const psDictHandle = ctx.handles.entityHandle('dxf:plotstyledict');
    w.pair(0, 'SECTION').pair(2, 'OBJECTS');
    // Root dictionary (owner = 0 by definition).
    w.pair(0, 'DICTIONARY').pair(5, rootHandle).pair(330, 0);
    w.pair(100, 'AcDbDictionary');
    w.pair(281, 1); // hard-owner flag off (soft ids)
    w.pair(3, 'ACAD_PLOTSTYLENAME').pair(360, psDictHandle);
    // Plot style name dictionary with the default 'Normal' record.
    w.pair(0, 'DICTIONARYWITHDEFAULT').pair(5, psDictHandle).pair(330, rootHandle);
    w.pair(100, 'AcDbDictionaryWithDefault');
    w.pair(281, 1);
    w.pair(3, 'Normal').pair(360, ctx.plotStyleNormal);
    // The default Normal plot style record (placeholder, like CTB databases).
    w.pair(0, 'ACDBPLACEHOLDER').pair(5, ctx.plotStyleNormal).pair(330, psDictHandle);
    w.pair(100, 'AcDbPlaceHolder');
    w.pair(0, 'ENDSEC');
}
